var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.821,
    height: 18.561,
    viewBox: "0 0 23.821 18.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.252,
    y1: 1.309,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb88ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b084e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69958",
    "data-name": "Raggruppa 69958",
    transform: "translate(5693.792 -1026.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36337",
    "data-name": "Tracciato 36337",
    d: "M11.4,12.567q-4.862,0-9.724,0c-.214,0-.3-.048-.33-.272C1.127,10.809.89,9.32.66,7.83.446,6.442.238,5.052.018,3.665a.781.781,0,0,1,.318-.852.758.758,0,0,1,.925.074Q3.317,4.419,5.368,5.958a1.074,1.074,0,0,0,1.746-.3Q8.84,3.075,10.567.49A.964.964,0,0,1,12.006.212a1.318,1.318,0,0,1,.271.327q1.74,2.6,3.479,5.209a1.059,1.059,0,0,0,1.043.52,1.13,1.13,0,0,0,.576-.259l4.068-3.046a1.113,1.113,0,0,1,.473-.26.748.748,0,0,1,.891.855c-.2,1.366-.422,2.73-.633,4.1q-.347,2.246-.688,4.494c-.063.418-.052.42-.482.42H11.4",
    transform: "translate(-5693.29 1027.445)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36338",
    "data-name": "Tracciato 36338",
    d: "M31.784,224.3q4.861,0,9.723,0c.209,0,.288.04.281.269-.017.632,0,1.265-.006,1.9a1.07,1.07,0,0,1-1.168,1.165H22.9a1.069,1.069,0,0,1-1.166-1.166c0-.641.008-1.281-.006-1.922,0-.208.07-.244.258-.243q4.9.008,9.794,0",
    transform: "translate(-5713.644 817.375)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.adeaa2061deaa3c7da37aeaa1bf09457.svg";
export { ForwardRef as ReactComponent };